<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <right-nav></right-nav>
    <home-nav></home-nav>
    <div>
      <div class="w">
        <div class="site-nav">
          <router-link :to="{name:'index'}">首页</router-link>>
          <router-link :to="{name:'qyd-home',}">趣运动</router-link>
        </div>
        <el-row class="goods-detail">
          <el-col :span="8">
            <div>
              <div class="big-img" :style="{'backgroundImage':`url(${bigImgUrl})`}"></div>
            </div>
            <div
              class="swiper-img-wrap"
              v-if="goodsInfo.venues_gallery&&goodsInfo.venues_gallery.length>0"
            >
              <div class="swiper-img" ref="scrollImg">
                <i class="el-icon el-icon-arrow-left" @click="scrollToLeft"></i>
                <div
                  class="myPics"
                  v-for="(item,index) in goodsInfo.venues_gallery"
                  :key="index"
                  @mouseenter="showBigImg(item)"
                  @click="showBigImg(item)"
                >
                  <img :src="item" alt="pics">
                </div>
                <i class="el-icon el-icon-arrow-right" @click="scrollToRight"></i>
              </div>
            </div>
          </el-col>
          <el-col :span="16" class="goods-texts">
            <h2>{{goodsInfo.venues_name}}</h2>
            <el-row class="price-wrap">
              <el-col :span="12">
                <span>{{goodsInfo.venues_average_price | yuan}}起</span>
                ( 上班族价 )
              </el-col>
            </el-row>
            <el-row class="goods-small-text">
              <el-col>
                <span>场馆地址</span>
                {{goodsInfo.venues_address}}
              </el-col>
              <el-col>
                <span>场馆电话</span>
                {{goodsInfo.venues_phone}}
              </el-col>
              <el-col class="Pos-r">
                <span>商品好评</span>
                <div class="star-gray">
                  <div class="star-red" :style="{'width':commentRate}"></div>
                </div>
              </el-col>
              <!-- <el-col v-if="goodsInfo.venues_notice">
                <span>温馨提示</span>
                {{goodsInfo.venues_notice}}
              </el-col>-->
            </el-row>
            <el-button @click="goToSomewhere('reserve')">立即预定</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="goods-images-description">
            <p>
              <span :class="{actived:curIndex==0}" @click="goToSomewhere('reserve')">场地预订</span>
              <span :class="{actived:curIndex==1}" @click="goToSomewhere('introduce')">场馆介绍</span>
            </p>
            <div class="reserve-wrap">
              <el-row class="reserve" id="reserve">
                <el-col :span="1.5">日期：</el-col>
                <el-col :span="3" v-for="(item,index) in goodsInfo.date_list" :key="index+'0'">
                  <span
                    :class="{actived:curDate==item}"
                    @click="curDate=item;getReserveInfo(item)"
                  >{{item |dateFormat2}}({{item | dayFormat2}})</span>
                </el-col>
              </el-row>
              <div class="court">
                <div class="left-time">
                  <div v-for="(time,index) in courtInfo.hour_list" :key="index+'1'">{{time}}-</div>
                </div>
                <div class="right-court">
                  <div v-for="item in courtInfo.goods_list" :key="item.field_id" class="item">
                    <div style="text-align:center" class="itemName">{{item.field_name}}</div>
                    <span
                      :class="{'green':i.status==0 ,'red':i.status==3}"
                      v-for="(i,j) in item.goods_item"
                      :key="i.goods_id"
                      @click="pickTime($event,i,item.goods_item[j+1],item.goods_item[j-1],item.field_id,item)"
                    >{{i.price | yuan}}</span>
                  </div>
                </div>
                <div class="right-intro">
                  <div class="hint">
                    <div>
                      <span class="green"></span>可预定
                    </div>
                    <div>
                      <span></span>不可预定
                    </div>
                    <div>
                      <span class="red"></span>当前选定
                    </div>
                  </div>
                  <div class="curent-reserve">
                    <div>
                      项目：
                      <span>{{curSport}}</span>
                    </div>
                    <div>
                      日期：
                      <span>{{curDate |dateFormat2}}</span>
                    </div>
                    <div>
                      场次：
                      <span></span>
                    </div>
                    <ul class="choose">
                      <li v-if="myPicker.length===0">请点击左侧列表选择场次</li>
                      <li
                        v-else
                        v-for="(item,index) in myPickerTxt"
                        :key="index"
                      >{{item.field}} {{item.start}}-{{item.end}} {{item.price | intYuan}}</li>
                    </ul>
                    <div class="txt">
                      已选
                      <span class="red">{{myPicker && myPicker.length}}</span> 场地
                    </div>
                    <div class="txt">
                      共计
                      <span class="red" style="font-size:24px">{{totalPrice}}</span> 元
                    </div>
                    <el-button
                      :class="{'btn-disabled ':totalPrice===0}"
                      :disabled="totalPrice===0"
                      @click="goConfirm"
                    >立即预定</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="other-infos-wrap" id="introduce">
              <h2 class="title">
                <span>场馆介绍</span>
              </h2>
              <div class="other-infos">
                <h3 v-if="goodsInfo.traffic_list && goodsInfo.traffic_list.length>0">
                  <span></span> 交通信息
                </h3>
                <p v-for="(i,k) in goodsInfo.traffic_list" :key="k+'0'">
                  <span>{{i.traffic_name}}</span>
                  <b>{{i.traffic_content}}</b>
                </p>
                <h3 v-if="goodsInfo.facility_list && goodsInfo.facility_list.length>0">
                  <span></span> 场地设施
                </h3>
                <p v-for="(i,k) in goodsInfo.facility_list" :key="k+'1'">
                  <span>{{i.facility_name}}</span>
                  <b>{{i.facility_content}}</b>
                </p>
                <h3
                  v-if="goodsInfo.venues_other_service && goodsInfo.venues_other_service.length>0"
                >
                  <span></span> 场馆服务
                </h3>
                <p v-for="(i,k) in goodsInfo.venues_other_service" :key="k">
                  <span>{{i.service_name}}</span>
                  <b>{{i.service_content}}</b>
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import DEFAULTGOODS from "@/assets/images/goods_default.jpg";
import {
  getCurrentDate,
  getWhenDate,
  dayFormat
} from "@/assets/js/timeFormat.js";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav
  },
  data() {
    return {
      curSport: "",
      curDate: "",
      goodsInfo: "",
      bigImgUrl: "",
      commentRate: 0,
      product_id: this.$route.query.product_id,
      curIndex: 0,
      defaultGoods: DEFAULTGOODS,
      courtInfo: "",
      myPicker: [],
      myPickerTxt: [],
      time: [],
      minHour: "",
      totalPrice: 0
    };
  },
  watch: {
    myPicker: function(val) {
      if (val.length > 4) {
        this.$alert("您选择的场次太多啦，请分两次结算");
      }
    },
    myPickerTxt: function(val) {
      this.totalPrice = 0;
      val.map(item => {
        this.totalPrice += parseInt(item.price.split("."));
      });
    }
  },
  mounted() {
    if (sessionStorage.getItem("sportsCate")) {
      this.sports = JSON.parse(sessionStorage.getItem("sportsCate"));
    } else {
      this.$reqGet("api/store/quyundong/category").then(res => {
        this.sports = res.data.data;
      });
    }
    this.sports.map(item => {
      if (item.id == this.$route.query.cate_id) {
        this.curSport = item.cat_name;
      }
    });
  },
  created() {
    this.getVeneusInfo();
    this.getReserveInfo();
  },
  methods: {
    getVeneusInfo() {
      this.$reqGet(
        "api/store/quyundong/showVenueFields/" + this.$route.query.veneus_id
      ).then(res => {
        let data = res.data.data;
        data.map(item => {
          if (item.cat_id == this.$route.query.cate_id) {
            this.goodsInfo = item;
            this.curDate = this.goodsInfo.date_list[0];
          }
        });
        this.commentRate = (this.goodsInfo.comment_avg / 5) * 100 + "%";
        this.bigImgUrl = this.goodsInfo.venues_gallery[0] || this.defaultGoods;
      });
    },
    getReserveInfo(date) {
      this.resetArray();
      let obj = {
        cat_id: this.$route.query.cate_id
      };
      if (date) {
        obj.book_date = this.curDate;
      }
      this.courtInfo = "";
      this.$reqGet(
        "api/store/quyundong/booking/" + this.$route.query.veneus_id,
        obj
      ).then(res => {
        this.groupList = [];
        this.courtInfo = res.data.data;
        this.minHour = this.courtInfo.min_hour;
        if (this.courtInfo.length !== 0) {
          this.courtInfo.goods_list.forEach(ele => {
            ele.group_list.forEach(e => {
              this.groupList.push(e.goods_ids);
            });
          });
        }

        this.checkHasBind();
      });
    },
    checkHasBind() {
      this.groupList1 = [];
      this.groupList2 = [];
      this.groupList.map((item, index) => {
        this.groupList1.push(item.split(",")[0]);
        this.groupList2.push(item.split(",")[1]);
      });
    },
    pickTime(e, i, j, h, id, p) {
      // console.log(i.status)
      if (i.status == 2) {
        this.$message({
          message: "该场次已出售",
          type: "warning"
        });
        return;
      }
      if (i.status == 1) {
        this.$message({
          message: "场地已被锁定，不可预定",
          type: "warning"
        });
        return;
      }
      if (i.status !== 3) {
        if (this.myPicker.length > 3) {
          this.$alert("您选择的场次太多啦，请分两次结算");
          return;
        }
        i.status = 3;
        this.myPicker.push(i.goods_id);
        this.myPickerTxt.push({
          field: p.field_name,
          start: i.hour,
          end: parseInt(i.hour.split(":")[0]) + 1 + ":00",
          price: i.price,
          date: this.curDate,
          sport:this.curSport
        });
        this.groupList1.forEach(item => {
          if (i.goods_id === item) {
            this.$set(i, "relate", 1);
            this.$set(j, "relate", -1);
            j.status = 3;
            this.myPicker.push(j.goods_id);
            this.myPickerTxt.push({
              field: p.field_name,
              start: j.hour,
              end: parseInt(j.hour.split(":")[0]) + 1 + ":00",
              price: j.price,
              date: this.curDate,
              sport:this.curSport
            });
          }
        });
        this.groupList2.forEach(item => {
          if (i.goods_id === item) {
            this.$set(i, "relate", -1);
            this.$set(h, "relate", 1);
            h.status = 3;
            this.myPicker.push(h.goods_id);
            this.myPickerTxt.push({
              field: p.field_name,
              start: h.hour,
              end: parseInt(h.hour.split(":")[0]) + 1 + ":00",
              price: h.price,
              date: this.curDate,
              sport:this.curSport
            });
          }
        });
      } else {
        i.status = 0;
        let index = this.myPicker.indexOf(i.goods_id);
        if (i.relate == 1) {
          j.status = 0;
          index = this.myPicker.indexOf(j.goods_id);
        } else if (i.relate == -1) {
          h.status = 0;
          index = this.myPicker.indexOf(h.goods_id);
        }
        this.myPicker.splice(index, 1);
        this.myPickerTxt.splice(index, 1);
      }
      this.pushTime(i, id);
    },
    pushTime(i, id) {
      let str = i.hour;
      let num = "";
      if (str.length === 4) {
        num = id + str.substring(0, 1);
        if (this.time.indexOf(parseInt(num)) == -1) {
          this.time.push(parseInt(num));
        } else {
          this.time.splice(this.time.indexOf(parseInt(num)), 1);
        }
      } else if (str.length === 5) {
        num = id + str.substring(0, 2);
        if (this.time.indexOf(parseInt(num)) == -1) {
          this.time.push(parseInt(num));
        } else {
          this.time.splice(this.time.indexOf(parseInt(num)), 1);
        }
      }

      this.time.sort((a, b) => {
        return a - b;
      });

      if (this.time.length == 4 && this.time[0] + 3 == this.time[3]) {
        this.min = 4;
      } else if (
        this.time.length == 4 &&
        (this.time[0] + 1 == this.time[1] && this.time[2] + 1 == this.time[3])
      ) {
        this.min = 2;
      } else if (
        this.time.length == 3 &&
        (this.time[0] + 2 == this.time[2] || this.time[1] + 2 == this.time[3])
      ) {
        this.min = 3;
      } else if (
        this.time.length == 2 &&
        (this.time[0] + 1 == this.time[1] ||
          this.time[1] + 1 == this.time[2] ||
          this.time[2] + 1 == this.time[3])
      ) {
        this.min = 2;
      } else {
        this.min = 1;
      }
    },
    resetArray() {
      this.myPicker = [];
      this.myPickerTxt = [];
    },
    showBigImg(imgUrl) {
      this.bigImgUrl = imgUrl;
    },
    scrollToLeft() {
      let scrollLeft = this.$refs.scrollImg.scrollLeft;
      if (scrollLeft != 0) {
        this.$refs.scrollImg.scrollLeft -= 86;
      }
    },
    scrollToRight() {
      let scrollLeft = this.$refs.scrollImg.scrollLeft;
      if (scrollLeft <= 176) {
        this.$refs.scrollImg.scrollLeft += 86;
      }
    },
    goToSomewhere(name) {
      document.getElementById(name).scrollIntoView(true);
    },
    goConfirm() {
      if (this.myPicker.length > 4) {
        this.$alert("您选择的场次太多啦，请分两次结算");
        return;
      }
      console.log(this.myPickerTxt)
      let obj = {
        venues_id: this.$route.query.veneus_id,
        cat_id: this.$route.query.cate_id,
        goods: this.myPicker,
        date: this.curDate,
        extra_data : this.myPickerTxt
      };
      if (this.min >= this.minHour) {
        this.$reqPost("api/store/quyundong_order/prepare_order", obj).then(
          res => {
            if (res.data.status == 200) {
              sessionStorage.setItem("reserveInfo", JSON.stringify(obj));
              sessionStorage.setItem(
                "orderInfo",
                JSON.stringify(res.data.data)
              );

              this.$router.push({
                name: "qyd-check-order"
              });
            }
          }
        );
      } else {
        this.$alert("该场馆需要连续预约" + this.minHour + "小时以上").then(
          () => {}
        );
      }
    }
  }
};
</script>

<style lang="less" scoped>
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.goods-detail {
  padding: 10px;
  background-color: #fff;
  .el-col:first-child {
    > div:first-child {
      padding-left: 13px;
      .big-img {
        width: 360px;
        height: 360px;
        background-size: cover;
        background-position: center;
      }
    }
    .swiper-img-wrap {
      position: relative;
      height: 85px;
      overflow: hidden;
      margin-top: 20px;
      padding: 0 20px;

      i {
        position: absolute;
        top: 40%;
        font-size: 20px;
        color: #bcbcbc;
      }
      i:first-child {
        left: -6px;
      }
      i:last-child {
        right: 0px;
      }
    }
    .swiper-img {
      height: 100px;
      overflow: hidden;
      white-space: nowrap;
      overflow-x: scroll;
      .myPics {
        width: 80px;
        height: 80px;
        border: 1px solid #dadada;
        display: inline-block;
        margin-right: 6.5px;
        &:hover {
          border: 1px solid #eb000e;
          border-radius: 3px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .goods-texts {
    padding-left: 20px;
    h2 {
      font-size: 24px;
      color: #000;
      margin-top: 0;
    }
    h3 {
      font-weight: normal;
      color: #fd6c17;
      font-size: 16px;
      margin: 8px 0;
    }
    .price-wrap {
      background-color: #eee;
      color: #999;
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      span {
        color: #eb000e;
        font-size: 24px;
        margin-right: 10px;
      }
      .el-col:first-letter {
        font-size: 16px;
      }
      a {
        color: #1b6cab;
      }
    }
    .goods-small-text {
      line-height: 40px;
      color: #222;
      min-height: 234px;
      padding-top: 30px;
      > div > span {
        color: #999;
        display: inline-block;
        width: 64px;
        text-align-last: justify;
        margin-right: 20px;
      }
      .star-gray {
        position: relative;
        top: 5px;
        width: 120px;
        height: 24px;
        display: inline-block;
        background-image: url("../../assets/images/star_g.png");
        background-repeat: repeat-x;
        margin-right: 20px;
        .star-red {
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          background-image: url("../../assets/images/star_r.png");
          background-repeat: repeat-x;
        }
      }
      .disabled {
        border: 1px dashed #aaa;
        background-color: #f0f0f0;
      }
    }
    .address {
      display: inline-block;
      width: 124px;
    }
    .el-button {
      width: 180px;
      height: 45px;
      background: rgba(226, 51, 63, 1);
      border: 1px solid rgba(226, 51, 63, 1);
      border-radius: 5px;
      font-size: 18px;
      color: #fff;
      margin: 10px 10px 10px 90px;
    }
  }
}
.btn-disabled {
  color: #bdbdbd !important;
  cursor: not-allowed !important;
  background-image: none !important;
  background-color: #efefef !important;
  border-color: #ddd !important;
}
.goods-images-description {
  margin-top: 15px;
  font-size: 0;
  background-color: #fff;
  > p:first-child {
    height: 52px;
    line-height: 52px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid #cdcdcd;
    margin: 0;
    span {
      display: inline-block;
      width: 214px;
      height: 52px;
      border: 1px solid #cdcdcd;
      border-top: none;
      border-bottom: none;
      font-size: 18px;
      line-height: 52px;
      text-align: center;
      padding: 0;
      cursor: pointer;
      &.actived {
        background: rgba(226, 51, 63, 1);
        color: #fff;
        border: 1px solid rgba(226, 51, 63, 1);
      }
    }
  }
  .reserve-wrap {
    background-color: #fff;
    .reserve {
      font-size: 20px;
      color: #333;
      padding: 30px 15px;
      .el-col:first-child {
        line-height: 36px;
      }
      .el-col {
        margin-right: 7px;
      }
      .el-col > span {
        display: inline-block;
        height: 36px;
        line-height: 36px;
        padding: 0 10px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        border-radius: 18px;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
        &.actived {
          background: rgba(226, 51, 63, 1);
          color: #fff;
        }
      }
    }
    .court {
      display: flex;
      padding-top: 10px;
      font-size: 16px;
      color: #999;
      flex-wrap: no-wrap;
    }
    .left-time {
      width: 80px;
      flex-wrap: wrap;
      margin-top: 45px;
      padding-left: 10px;
    }
    .left-time > div {
      height: 40px;
      line-height: 40px;
      text-align: right;
      margin-right: 5px;
      margin-bottom: 2px;
    }
    .right-court {
      width: 730px;
      background: #f5f5f5;
      padding: 10px;
      border: 1px solid #cdcdcd;
      overflow-x: auto;
      white-space: nowrap;
    }
    .right-court > .item {
      width: 60px;
      cursor: pointer;
      display: inline-block;
      white-space: normal;
    }
    .right-court > .item .itemName {
      line-height: 30px;
    }
    .right-court > .item > span {
      display: inline-block;
      width: 100%;
      height: 40px;
      background: #cdcdcd;
      border-top: 2px solid #fff;
      border-left: 2px solid #fff;
      color: #cdcdcd;
      text-align: center;
      line-height: 40px;
    }
    .right-court > .item > div {
      height: 34px;
      line-height: 13px;
    }
    .right-court > .item .red {
      background: #e2333f;
      color: #fff;
    }
    .right-court > .item .green {
      background: #70d24f;
      color: #fff;
    }
    .right-intro {
      border: 1px solid #cdcdcd;
      border-left: none;
      width: 360px;
      font-size: 14px;
      .hint {
        width: 90%;
        height: 55px;
        justify-content: center;
        display: flex;
        color: #999;
        text-align: center;
        border-bottom: 1px solid #cdcdcd;
        box-sizing: border-box;
        padding: 18px 0;
        margin: 0 15px;
        > div {
          width: 80px;
          height: 20px;
          line-height: 20px;
          margin-right: 10px;
          span {
            width: 20px;
            height: 20px;
            background: #dcdcdc;
            float: left;
          }
          .green {
            background: #70d24f;
          }
        }
        .red {
          background: #e2333f;
        }
      }
      .curent-reserve {
        color: #999;
        padding: 10px 15px;
        > div {
          line-height: 26px;
          > span {
            color: #222;
          }
        }
        .choose {
          margin: 20px 0;
          li {
            width: 250px;
            height: 36px;
            border: 2px solid rgba(207, 207, 207, 1);
            border-radius: 5px;
            text-align: center;
            line-height: 36px;
            color: #666;
            margin: 10px auto;
          }
        }
        .txt {
          color: #666;
          line-height: 34px;
          .red {
            color: #e2333f;
          }
        }
        .el-button {
          display: block;
          width: 180px;
          height: 45px;
          background: rgba(226, 51, 63, 1);
          border: 1px solid rgba(226, 51, 63, 1);
          border-radius: 5px;
          font-size: 18px;
          color: #fff;
          margin: 30px auto;
        }
      }
    }
  }
}
.other-infos-wrap {
  font-size: 16px;
  padding: 30px;
  .title {
    font-size: 24px;
    border-bottom: 2px solid #ececec;
    height: 50px;
    line-height: 50px;
    color: #222;
    > span {
      display: inline-block;
      width: 107px;
      border-bottom: 2px solid #e2333f;
      padding-left: 3px;
    }
  }
  .other-infos {
    padding: 0 50px;
    color: #222;
    h3 {
      background-color: #f3f3f3;
      line-height: 32px;
      margin: 0;
      margin-top: 40px;
      padding-left: 35px;
      font-weight: normal;
    }
    p {
      line-height: 40px;
      margin: 0;
      letter-spacing: -6px;
      span {
        display: inline-block;
        width: 140px;
        text-align: center;
        color: #666;
        border-right: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
        letter-spacing: 0;
      }
      b {
        display: inline-block;
        width: 892px;
        letter-spacing: 0;
        border-bottom: 1px solid #e6e6e6;
        font-weight: normal;
        padding-left: 40px;
        box-sizing: border-box;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/products/qyd-detail.vue